import { useNavigate } from "react-router-dom";
import urls from "../../../config/urls.json";
import { useSession } from "../../../hooks/useSession";
import { useAppointmentResponse } from "../../../hooks/useAppointmentResponse";
import { useDynatrace } from "../../../hooks/useDynatrace";

export const useDatiPersonaliRiconosciutoPage = () => {
    const navigate = useNavigate();
    const { read, update, batchUpdate } = useSession();
    const { handleAppointmentC5Submission, isCreaAppuntamentoBusy, isCreaAppuntamentoError, fetchErrorMessage, fetchError, setFetchError } = useAppointmentResponse();

    const edit = () => {
        // update("email", "");
        // update("cellulare", "");
        batchUpdate({
            email: "",
            cellulare: "",
        });
        navigate(urls.datiPersonaliNonRiconosciutoC5.path, { replace: true, state: { lockFields: true } });
        // navigate("/c5/fissa-appuntamento/dati-personali-riconosciuto", { replace: true, state: { lockFields: true } });
    };

    const next = async () => {
        handleAppointmentC5Submission();
    };

    const {} = useDynatrace();

    return {
        edit,
        next,
        read,
        isCreaAppuntamentoBusy,
        isCreaAppuntamentoError,
        fetchErrorMessage,
        fetchError,
        setFetchError,
    };
};
